import check from './check.vue'
export default check